import { isValidSharpCharts2DateString } from '@/utils/isValidSharpCharts2DateString';
import { MIN_ALLOWED_DATE_STRING } from '@/enums/min-allowed-date-string';

export function isSharpCharts2DateStringOlderThanMinimumAllowed(dateString: string) {
  if (
    !isValidSharpCharts2DateString(dateString) ||
    !dateString
  ) {
    return false;
  }

  const dateParts = dateString.split('-');
  const [year, month, day] = dateParts.map(Number);

  const minDateParts = MIN_ALLOWED_DATE_STRING.split('-');
  const [minDateYear, minDateMonth, minDateDay] = minDateParts.map(Number);

  const isInvalidYear = year < minDateYear;
  const isInvalidMonth = year <= minDateYear && month < minDateMonth;
  const isInvalidDay = year <= minDateYear && month <= minDateMonth && day < minDateDay;

  return isInvalidYear || isInvalidMonth || isInvalidDay;
}
